<template>
    <div>
        <v-label>
            <b>{{ label }}</b>
        </v-label>

        <!-- Autocomplete Local / Full -->
        <v-autocomplete v-if="autocomplete && full" :ref="'sgeneric' + label" :clearable="clearable"
            :return-object="returnObject" :items="items" :disabled="disabled" :readonly="readonly" :item-text="itemtext"
            :item-value="itemvalue" :value="valueLocal" :autofocus="autofocus" :error="hasError"
            :error-messages="errorMessage" :rules="computedRules" :multiple="multiple" placeholder="Seleccione opción"
            hide-details="auto" outlined dense @input="input($event)" @change="change($event)">
            <template v-if="slotItem" v-slot:item="data">
                <slot name="item" :item="data.item"> </slot>
            </template>
            <template v-slot:prepend-inner>
                <slot name="prepend-inner"> </slot>
            </template>
            <template v-slot:append> </template>
            <template v-slot:append-outer>
                <v-icon v-if="add" style="cursor: pointer; margin-top: 3px" color="success darken-1"
                    @click="addEvent()">
                    mdi-plus-circle-outline
                </v-icon>
                <slot v-else name="append-outer"> </slot>
            </template>
        </v-autocomplete>

        <!-- Autocomplete Remoto con búsqueda -->
        <v-autocomplete v-if="autocomplete && !full" :ref="'sgeneric' + label" :clearable="clearable"
            :return-object="returnObject" :item-value="itemvalue" :item-text="itemtext" :items="items"
            :disabled="disabled" :readonly="readonly" :search-input.sync="search" :value="valueLocal"
            :autofocus="autofocus" :error="hasError" :error-messages="errorMessage" :rules="computedRules"
            :multiple="multiple" :clear-icon-cb="onClearClicked" no-filter auto-select-first hide-details="auto"
            outlined dense placeholder="Digite opción" @click:clear="items = []" @input="input($event)"
            @change="change($event)">
            <template v-if="slotItem" v-slot:item="data">
                <slot name="item" :item="data.item"> </slot>
            </template>
            <template v-slot:prepend-inner>
                <slot name="prepend-inner"> </slot>
            </template>
            <template v-slot:append> </template>
            <template v-slot:append-outer>
                <v-icon v-if="add" style="cursor: pointer; margin-top: 3px" color="success darken-1"
                    @click="addEvent()">
                    mdi-plus-circle-outline
                </v-icon>
                <slot v-else name="append-outer"> </slot>
            </template>
        </v-autocomplete>

        <!-- Select tradicional -->
        <v-select v-if="!autocomplete" :ref="'sgeneric' + label" :return-object="returnObject" :item-value="itemvalue"
            :item-text="itemtext" :disabled="disabled" :readonly="readonly" :items="items" :clearable="clearable"
            :value="valueLocal" :autofocus="autofocus" :error="hasError" :error-messages="errorMessage"
            :rules="computedRules" :multiple="multiple" :clear-icon-cb="onClearClicked" hide-details="auto" dense
            outlined placeholder="Seleccione opción" @input="input($event)" @change="change($event)">
            <template v-if="slotItem" v-slot:item="data">
                <slot name="item" :item="data.item"> </slot>
            </template>
            <template v-slot:prepend-inner>
                <slot name="prepend-inner"> </slot>
            </template>
            <template v-slot:append> </template>
            <template v-slot:append-outer>
                <v-icon v-if="add" style="cursor: pointer; margin-top: 3px" color="success darken-1"
                    @click="addEvent()">
                    mdi-plus-circle-outline
                </v-icon>
                <slot v-else name="append-outer"> </slot>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    name: "SelectG",
    components: {},
    props: {
        value: null,
        itemtext: {
            type: String,
            default: "GenDescription",
        },
        itemvalue: {
            type: String,
            default: "GenValue",
        },
        typeInput: {
            type: Boolean,
            default: false,
        },
        noDefault: {
            type: Boolean,
            default: false,
        },
        add: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        onClear: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: "GenValue",
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
        full: {
            type: Boolean,
            default: false,
        },
        config: {
            type: Object,
            default: null,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: "",
        },
        slotItem: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },

    created() {
        if (this.value > 0) this.tempValue = this.value;
        this.valueLocal = this.value;
        if (this.text && this.value) {
            this.items = [{ [this.itemvalue]: this.value, [this.itemtext]: this.text }];
        }

        this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);
        if (this.text) {
            if (this.autocomplete && !this.full) {
                this.search = this.text;
                this.getAnswer(true);
                return;
            }
        }
        this.load();
    },
    data: () => ({
        tempValue: 0,
        valueLocal: null,
        search: "",
        item: null,
        items: [],
        val: "",
        textNull: false,
        isLoading: false,
        model: null,
        hasError: false,
        errorMessage: "",
        params: {},
    }),

    computed: {
        computedRules() {
            let currentRules = [];
            if (this.hasError && this.errorMessage) {
                currentRules.push(() => this.errorMessage);
            }
            return currentRules;
        },
    },

    watch: {
        valueLocal() {
            this.$emit("input", this.valueLocal);
        },
        value() {
            this.tempValue = this.value;
            if (this.full && Array.isArray(this.items) && this.items.length > 0 && this.value !== null && this.value !== undefined && this.value !== "") {
                let match = this.items.find((x) =>
                    x[this.itemvalue] == this.value ||
                    x[this.itemtext] == this.value ||
                    (typeof this.value === "object" && this.value !== null && x[this.itemvalue] == this.value[this.itemvalue])
                );
                if (match) {
                    this.valueLocal = this.returnObject ? match : match[this.itemvalue];
                    this.$emit("input", this.valueLocal);
                    if (this.returnObject) this.$emit("returnObject", match);
                    return;
                }
            }
            this.valueLocal = this.value;
            if (this.text && this.value) {
                const exists = this.items && this.items.some((x) => x[this.itemvalue] == this.value);
                if (!exists) {
                    this.items = [{ [this.itemvalue]: this.value, [this.itemtext]: this.text }];
                }
            }

            if (this.full && (!this.items || this.items.length === 0)) {
                this.load();
            }
        },
        config: {
            handler() {
                this.tempValue = this.value;
                if (!this.value) {
                    this.valueLocal = null;
                } else {
                    this.valueLocal = this.value;
                    if (this.text) {
                        const exists = this.items && this.items.some((x) => x[this.itemvalue] == this.value);
                        if (!exists) {
                            this.items = [{ [this.itemvalue]: this.value, [this.itemtext]: this.text }];
                        }
                    }
                }
                this.load();
            },
            deep: true,
        },
        text() {
            const currentVal = this.valueLocal || this.value;
            if (this.text && currentVal) {
                const exists = this.items && this.items.some((x) => x[this.itemvalue] == currentVal);
                if (!exists) {
                    this.items = [{ [this.itemvalue]: currentVal, [this.itemtext]: this.text }];
                }
            }
            if (this.autocomplete)
                if (this.text) if (!this.full) this.search = this.text;
            if (this.text != null && this.text != "") {
                this.textNull = false;
            }

            if (this.full && (!this.items || this.items.length === 0)) {
                this.load();
            }
        },
        search() {
            if (this.search) {
                if (this.search != this.text) {
                    this.textNull = true;
                }
                if (this.search.length < 3) {
                    const currentVal = this.valueLocal || this.value;
                    if (currentVal && this.text) {
                        this.items = [{ [this.itemvalue]: currentVal, [this.itemtext]: this.text }];
                    } else {
                        this.items = [];
                    }
                } else {
                    this.debouncedGetAnswer();
                }
            } else {
                const currentVal = this.valueLocal || this.value;
                if (currentVal && this.text) {
                    this.items = [{ [this.itemvalue]: currentVal, [this.itemtext]: this.text }];
                }
            }
        },
    },

    created() {
        if (this.value > 0) this.tempValue = this.value;
        this.$nextTick().then(() => {
            this.valueLocal = this.value;
            this.$emit("input", this.valueLocal);
        });

        this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);
        if (this.text && this.autocomplete && !this.full) {
            this.search = this.text;
            this.getAnswer(true);
            return;
        }
        this.load();
    },

    methods: {
        onClearClicked() {
            if (this.onClear) {
                this.$emit("onClearClicked");
            }
        },
        isFocused(val) {
            if (this.$refs["sgeneric" + this.label]) {
                this.$refs["sgeneric" + this.label].isFocused = val;
            }
        },
        focus() {
            if (this.$refs["sgeneric" + this.label]) {
                this.$refs["sgeneric" + this.label].focus();
            }
        },
        getAnswer(first) {
            if (!this.full && this.search != null && this.search.length > 2 && this.autocomplete && this.config != null) {
                if (this.config.params != null) {
                    this.params = { ...this.config.params };
                    this.params.search = this.search;
                    this.params.requestID = this.$fun.getUserID();
                } else {
                    this.params = {
                        search: this.search,
                        requestID: this.$fun.getUserID(),
                    };
                }

                this.$http.post(this.config.url, {}, { params: this.params }).then((r) => {
                    if (r.status == 200) {
                        this.items = r.data;
                        this.$emit("updateData", this.items);
                        if (first || ((this.text != null || this.text != "") && !this.textNull)) {
                            if (!this.returnObject)
                                this.valueLocal = this.items.length > 0 ? this.items[0][this.itemvalue] : this.valueLocal;
                            else {
                                this.valueLocal = this.items.length > 0 ? this.items[0] : this.valueLocal;
                            }
                            this.$http.post(this.config.url, {}, { params: this.params }).then((r) => {
                                if (r.status == 200) {
                                    let result = Array.isArray(r.data) ? r.data : [];
                                    const currentVal = this.valueLocal || this.value;
                                    if (currentVal && this.text && !result.some((x) => x[this.itemvalue] == currentVal)) {
                                        result.unshift({ [this.itemvalue]: currentVal, [this.itemtext]: this.text });
                                    }
                                    this.items = result;
                                    this.$emit("change", this.items);
                                    if (currentVal) {
                                        const found = this.items.find((x) => x[this.itemvalue] == currentVal);
                                        if (found) {
                                            this.valueLocal = this.returnObject ? found : found[this.itemvalue];
                                        } else {
                                            this.valueLocal = currentVal;
                                        }
                                    } else if (first || ((this.text != null || this.text != "") && !this.textNull)) {
                                        if (this.items.length > 0 && !this.noDefault) {
                                            this.valueLocal = this.returnObject ? this.items[0] : this.items[0][this.itemvalue];
                                        }
                                    }
                                    this.$emit("input", this.valueLocal);
                                }
                            });
                        }
                    }
                });
            }
        },
        addEvent() {
            this.$emit("add");
        },
        getInnerSelect() {
            const refName = "sgeneric" + (this.label || "");
            return this.$refs[refName] || this.$refs.sgeneric || this.$refs.generic || this.$refs.select;
        },
        focus() {
            const select = this.getInnerSelect();
            if (select && typeof select.focus === "function") {
                select.focus();
            }
        },
        error(msg) {
            this.errorMessage = msg || "Campo obligatorio";
            this.hasError = true;
            this.$nextTick(() => {
                this.focus();
            });
        },
        input(value) {
            this.hasError = false;
            this.errorMessage = "";
            this.valueLocal = value;
            this.$emit("input", value);
        },
        change(value) {
            this.$emit("change", value);
        },
        load() {
            if (this.autocomplete && !this.full) {
                const currentVal = this.valueLocal || this.value;
                if (currentVal && this.text) {
                    const exists = this.items && this.items.some((x) => x[this.itemvalue] == currentVal);
                    if (!exists) {
                        this.items = [{ [this.itemvalue]: currentVal, [this.itemtext]: this.text }];
                    }
                }
            } else {
                if (this.config != null) {
                    this.tempValue = this.value;
                    this.$http.post(this.config.url, {}, { params: this.config.params }).then((r) => {
                        if (r.status == 200) {
                            let result = Array.isArray(r.data) ? r.data : [];
                            const currentVal = this.valueLocal || this.value;
                            if (currentVal && this.text && !result.some((x) => x[this.itemvalue] == currentVal)) {
                                result.unshift({ [this.itemvalue]: currentVal, [this.itemtext]: this.text });
                            }
                            this.items = result;
                            this.$emit("change", this.items);
                            if (this.items.length > 0) {
                                let targetVal = (this.value !== null && this.value !== undefined && this.value !== 0) ? this.value : (this.valueLocal || this.tempValue);
                                if ((targetVal !== 0 && targetVal !== null && targetVal !== undefined) || this.noDefault) {
                                    if (this.items.find((x) => x[this.itemvalue] == targetVal)) {
                                        this.valueLocal = targetVal;
                                    } else this.valueLocal = targetVal;
                                    this.$emit("input", this.valueLocal);
                                } else {
                                    if (!this.returnObject) {
                                        if (this.items.find((x) => x == targetVal)) {
                                            this.valueLocal = targetVal;
                                        } else this.valueLocal = this.items[0][this.itemvalue];
                                    } else {
                                        let obj = null;
                                        if (targetVal)
                                            obj = this.items.find((x) => x[this.itemvalue] == targetVal[this.itemvalue]);
                                        if (obj) this.valueLocal = obj;
                                        else {
                                            this.valueLocal = this.items[0];
                                            if (this.noDefault) this.valueLocal = null;
                                        }
                                    }
                                    this.$emit("input", this.valueLocal);
                                }
                                this.$emit("input", this.valueLocal);
                            } else {
                                if (!this.valueLocal && this.value) {
                                    this.valueLocal = this.value;
                                }
                                if (this.valueLocal == null && !this.value) {
                                    this.valueLocal = null;
                                    this.$emit("input", this.valueLocal);
                                }
                            }
                        } else {
                            this.valueLocal = null;
                            this.$emit("input", this.valueLocal);
                        }

                        this.$emit("updateData", this.items);
                    }
                    );
                }
            }
        }
    }
}
</script>

<style></style>